import { Trans, t } from '@lingui/macro';
import { Search } from 'lucide-react';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';

export default function SearchBar({ value, onChange }) {
    return (
        <div className="flex w-full max-w-xl items-center gap-2">
            <div className="relative flex-1">
                <Search
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
                    size={18}
                    aria-hidden
                />
                <label htmlFor="event-search" className="sr-only">
                    <Trans>Search events</Trans>
                </label>
                <Input
                    id="event-search"
                    className="!h-[46px] pl-10 border border-solid shadow-none font-inter text-foreground focus:border-primary/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    placeholder={t`Search events...`}
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            </div>
            <Button className="h-[46px] px-6">
                <Trans>Search</Trans>
            </Button>
        </div>
    );
}
